import { uploadFile } from '@backrs_ui/grow-ui/src/utils/uploadFile';

const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png'] as const;

type UploadImageParams = Readonly<{
  file: File;
  token: string;
  userId: number;
}>;

export const isValidImageType = (file: File): boolean => {
  return ALLOWED_IMAGE_TYPES.includes(file.type as (typeof ALLOWED_IMAGE_TYPES)[number]);
};

export const uploadImage = async ({ file, token }: UploadImageParams) => {
  if (!isValidImageType(file)) {
    throw new Error('Invalid image type');
  }

  return uploadFile({
    file,
    token,
  });
};
